import Tab from '../../node_modules/bootstrap.native/dist/components/tab-native.esm.js';

import AddToCart from '../../modules/add-to-cart/js/app.js';
import AddToCartBundles from '../../modules/add-to-cart/js/views/bundles.js';
import AddToQuote from '../../modules/add-to-quote/js/app.js';
import ProductOptions from '../../modules/product-options/js/app.js';
import AddToWishList from '../../modules/add-to-wishlist/js/app.js';
import ProductAskQuestionApp from '../../modules/product-ask-question/js/app.js';
//import PriceMatchApp from '../../modules/price-match/js/app.js';
import ProductLeaseApp from '../../modules/product-lease/js/app.js';
import ProductInStockApp from '../../modules/product-in-stock/js/app.js';
import ReviewFeedbackApp from '../../modules/review-feedback/js/app.js';
//import BundlesApp from '../../modules/bundles/js/app.js';
import ProductMapPricing from '../../modules/product-map-pricing/js/app.js';
//import FreeFreightApp from '../../modules/free-freight/js/free-freight.js';
//import RegularlyStockedApp from '../../modules/regularly-stocked/js/regularly-stocked.js';
import ProductAccessoriesApp from '../../modules/accessories/js/app.js';
import PrivateClientAdvisor from '../../modules/private-client-advisor/js/app.js';
import ProductUtils from './product/utils.js';
import ProductImagesApp from './product/images.js';
import ProductVideosApp from './product/videos.js';
import ProductRelatedProducts from './product/related-products.js';
import MobileTabs from './product/mobile-tabs.js';
import LoginForPriceApp from './common/login-for-price.js';
import checkMapPricing from '../utils/check-map-pricing.js';
import SessionContactInfo from '../../modules/session/js/contact-info.js';
import ProductReviewImages from './product/review-images.js';

class ProductApp {
	constructor() {

		this.settings = window.SiteSettings || {};
		this.product_settings = window.ProductSettings || {};
		this.track_ga_events = typeof this.settings.GA_SHOPPING_CART_EVENTS === 'undefined' ? false : this.settings.GA_SHOPPING_CART_EVENTS;

		this.selectors = {
			add_to_cart: '.app-add-to-cart',
			add_to_cart_bundles: '.js-bundle-to-cart',
			add_to_quote: '.app-add-to-quote',
			add_to_wishlist: '.app-add-to-wishlist',
			product_options: '.js-product-options',
			price: '.js-product-price-label',
			price_original: '.js-product-price-original',
			map_price: '.app-map-pricing',
			accessories: '.js-accessories',
			product_tier_discount: '.js-product-tier-discount-placeholder',
			sticky_footer: '.js-cart-sticky-footer',
			cart_modal_placeholder: '.app-cart-modal-placeholder',
			add_to_cart_controls: '.add-to-cart'
		};

		new ProductImagesApp();
		new ProductVideosApp();
		new LoginForPriceApp();
		new ProductReviewImages();

		this.initMapPricingCheck();
		this.initMapPricing(() => {
			this.productInCart();
		});
		this.enableAddToCartBtns();
		this.additionalProductInCart();
		this.initWishList();
		this.initProductAskQuestionApp();
		this.initAccessories();
		this.initRelatedProducts();
		this.initReviewFeedback();
		//this.initFreeFreightPopup();
		//this.initRegularlyStockedPopup();
		this.initPrivateClientAdvisor();
		this.initProductInStock();
		this.checkCustomerLogin();
		this.checkContactInfo();
		this.initTabs();
	}

	enableAddToCartBtns () {
		const controls = document.querySelectorAll(this.selectors.add_to_cart_controls);

		controls.forEach(elem => elem.classList.remove('d-none'));
	}

	initAccessories () {
		const accessories = document.querySelector(this.selectors.accessories);

		if (accessories) {
			new ProductAccessoriesApp();
		}
	}

	openFibChat () {
		var chatElement = document.querySelector('#fib-chat-container');

		if(chatElement) {
			chatElement.dispatchEvent(new window.CustomEvent('fib_chat:open', null));
		}
	}

	initPrivateClientAdvisor () {
		new PrivateClientAdvisor({
			el: '.private-client-advisor-placeholder',
			init_chat: this.openFibChat
		});
	}

	initRelatedProducts () {
		const products = document.querySelector('.js-related-products-list');

		if (products) {
			new ProductRelatedProducts({
				container: '.js-related-products-list'
			});
		}
	}

	initProductInStock () {
		const el = document.querySelector('.js-check-availability');

		if (el) {
			if (window.Session) {
				window.Session.get('Customer')
					.then((customer) => {
						new ProductInStockApp({
							el: el,
							modal_placeholder_selector: '.product-in-stock-modal-placeholder',
							customer: customer
						});
					});
			} else {
				new ProductInStockApp({
					el: el,
					modal_placeholder_selector: '.product-in-stock-modal-placeholder',
					customer: null
				});
			}
		}
	}

	initAddToCart (product, in_stock_qty) {
		const allow_duplicates = typeof this.settings.ALLOW_CART_DUPLICATES === 'undefined' ? false : this.settings.ALLOW_CART_DUPLICATES;
		const show_popup = typeof this.settings.SHOW_CART_POPUP === 'undefined' ? false : this.settings.SHOW_CART_POPUP;
		const product_options = document.querySelector(`${this.selectors.product_options} .js-product-options-form`);

		let separate_accessory = false;
		let options_active = true;

		if (this.product_settings.SoldAccessorySeparately) {
			separate_accessory = true;
		}

		if (!product_options) {
			options_active = false;
		}

		new AddToCart({
			el: this.selectors.add_to_cart,
			product_id: window.Session.product_id,
			cart_product: product,
			in_stock_qty: in_stock_qty,
			allow_duplicates: allow_duplicates,
			show_popup: show_popup,
			accessories: this.selectors.accessories,
			adv_source: ProductUtils.is_adv_source(),
			map_policy: this.product_settings.MapPolicy ? this.product_settings.MapPolicy.Code : null,
			variations: this.product_settings.Variations || false,
			sticky_footer: this.selectors.sticky_footer,
			track_ga_events: this.track_ga_events,
			is_accessory: separate_accessory ? false : this.product_settings.IsAccessory,
			cart_modal_placeholder: this.selectors.cart_modal_placeholder,
			options_active: options_active
		});

		new AddToCartBundles({
			btnSelector: this.selectors.add_to_cart_bundles
		});
	}

	initAddToQuote () {
		const product_options = document.querySelector(`${this.selectors.product_options} .js-product-options-form`);
		const add_to_quote_el = document.querySelector(this.selectors.add_to_quote);
		let separate_accessory = !!this.product_settings.SoldAccessorySeparately;

		if (add_to_quote_el) {
			window.Session.get('QuoteRequest')
				.then(function (quote) {
					new AddToQuote({
						el: this.selectors.add_to_quote,
						product_id: window.Session.product_id,
						quote: quote,
						is_accessory: separate_accessory ? false : this.product_settings.IsAccessory,
						options_active: !!product_options
					});
				}.bind(this));
		}
	}

	initProductOptions (discount) {
		const product_options = document.querySelector(this.selectors.product_options);
		if (product_options) {
			product_options.classList.remove('hide');
			new ProductOptions({
				el: this.selectors.product_options,
				el_price: this.selectors.price,
				el_price_original: this.selectors.price_original,
				product_id: window.Session.product_id,
				discount: discount
			});
		}
	}

	productInCart () {
		if (window.Session) {
			window.Session.product_in_cart()
				.then( function (options) {
					const add_to_cart_el = document.querySelector(this.selectors.add_to_cart);
					const product = options.product;
					const product_info = options.product_info;

					let in_stock_qty = 0;
					let discount = 0;
					let outofstock = false;

					if (product_info) {
						outofstock = ProductUtils.check_product_outofstock(product_info);
						ProductUtils.check_product_availability(product_info);
						if (product_info.DynamicNumbers) {
							if (product_info.DynamicNumbers.qty) {
								in_stock_qty = product_info.DynamicNumbers.qty;
							}
							if (product_info.DynamicNumbers.price && !this.product_settings.UseMapPrice) {
								ProductUtils.update_price(product_info.DynamicNumbers.price);
							}
							if (product_info.DynamicNumbers.discount) {
								discount = product_info.DynamicNumbers.discount;
							}
						}

						if (product_info.IsAvailableForCart && product_info.Availability.Available) {
							// Ignore stock qty if IsAvailableForCart
							if (in_stock_qty <= 0) {
								in_stock_qty = this.settings.SHOPPING_CART_MAX_QTY ? this.settings.SHOPPING_CART_MAX_QTY : 1000;
							}
							this.initAddToCart(product, in_stock_qty);
						}

						this.initAddToQuote();

						if (add_to_cart_el) {
							add_to_cart_el.addEventListener('rendered', () => {
								ProductUtils.check_product_has_been_removed( product_info, window.Session.product_id );
							});
						}

						if (this.product_settings.LeasePrice) {
						 	new ProductLeaseApp({
								placeholder: '.product-lease-modal-placeholder',
						 		product_id: window.Session.product_id,
						 		product_price: product_info.DynamicNumbers.price
						 	});
						}
						/*
						new PriceMatchApp({
							placeholder: '.price-match-modal-placeholder'
						});
						*/

						if (!outofstock) {
							this.initProductOptions(discount);
						}
					}
				}.bind(this));
		}
	}

	additionalProductInCart () {
		if (window.Session) {
			window.Session.get('ShoppingCart').then( shopping_cart => {
				if( shopping_cart.Products ) {
					shopping_cart.Products.forEach( product => {
						const products = document.querySelectorAll(`[data-prodid="${product.ProductId}"]`);
						products.forEach( element => {
							const btn = element.querySelector('[name="add_to_cart"]');
							if (btn) {
								btn.classList.add('in-cart');
								btn.textContent = 'In cart';
							}
						});
					});
				}
			});
		}
	}

	initWishList () {
		if (window.Session) {
			window.Session.get('ProductInfo').then(product_info => {
				new AddToWishList({
					el: this.selectors.add_to_wishlist,
					product_id: window.Session.product_id,
					logged_user: product_info.DynamicNumbers,
					in_wishlist: product_info.InWishlist
				});
			});
		}
	}

	initProductAskQuestionApp () {
		if (window.Session) {
			window.Session.get('Customer')
				.then((customer) => {
					new ProductAskQuestionApp({
						placeholder: '.ask-question-modal-placeholder',
						customer: customer
					});
				});
		}
	}

	initReviewFeedback () {
		const elements = document.querySelectorAll('.js-review-feedback');

		elements.forEach(feedback => {
			new ReviewFeedbackApp({
				el: feedback
			});
		});

	}
/*
	initFreeFreightPopup () {
		const btn = '[data-popup-source="free_freight_html"]';
		const placeholder_selector = '.free-freight-modal-placeholder';
		const modal_selector = '.app-free-freight-modal';

		new FreeFreightApp({ placeholder_selector, modal_selector, btn });
	}

	initRegularlyStockedPopup () {
		const btn = '[data-popup-source="product_stocked_item"]';
		const placeholder_selector = '.regularly-stocked-modal-placeholder';
		const modal_selector = '.app-regularly-stocked-modal';

		new RegularlyStockedApp({ placeholder_selector, modal_selector, btn });
	}
*/

	initMapPricing (cb) {
		Promise.all([window.Session.get('Customer'), window.Session.get('ContactInfo'), window.Session.get('ProductInfo'), window.Session.product_in_cart()])
			.then(([customer, contact_info, product_info, product_in_cart]) => {
				let customer_logged_in = false;
				let customer_is_approved = false;
				let separate_accessory = false;

				if (this.product_settings.SoldAccessorySeparately) {
					separate_accessory = true;
				}

				/*
				new BundlesApp({
					track_ga_events: this.track_ga_events
				});
				*/

				if (customer && !customer.guest) {
					customer_logged_in = true;
					customer_is_approved = customer.is_approved;
				} else if (contact_info) {
					customer_logged_in = true;
				}

				if (this.settings.PRODUCT_PRICE_POLICY && this.settings.PRODUCT_PRICE_POLICY === 'MAP') {
					if (this.product_settings.UseMapPrice && !separate_accessory) {
						this.productMapPricing = new ProductMapPricing({
							customer_logged_in: customer_logged_in,
							customer_is_approved: customer_is_approved,
							adv_source: ProductUtils.is_adv_source(),
							product_in_cart: !!product_in_cart.product,
							product_info
						});
					}

					if (window.ProductListMapPrices) {
						// Accessories and Related Products
						window.ProductListMapPrices.initialize( {
							user: customer,
							selectors: {
								products: this.selectors.accessories + ' .item'
							}
						});
					}
				}
				cb();
			});
	}

	checkCustomerLogin () {
		if (window.Session) {
			window.Session.get('Customer')
				.then((customer) => {
					if (customer && !customer.guest) {
						const logged_els = document.querySelectorAll('.js-logged-user-elements');
						const unlogged_els = document.querySelectorAll('.js-unlogged-user-elements');

						if (logged_els.length > 0) {
							logged_els.forEach(elem => elem.classList.remove('d-none'));
						}
						if (unlogged_els.length > 0) {
							unlogged_els.forEach(elem => elem.remove());
						}
					}
				});
		}
	}

	initMapPricingCheck () {
		if (this.settings.PRODUCT_PRICE_POLICY && this.settings.PRODUCT_PRICE_POLICY === 'MAP') {
			Promise.all([window.Session.get('Customer'), window.Session.get('ContactInfo')])
				.then((results) => {
					checkMapPricing(results[0], results[1]);
				});
		}
	}

	checkContactInfo () {
		new SessionContactInfo();

		document.addEventListener('[Session]:has_user_info', (e) => {
			window.Session.get('Customer')
				.then((customer) => {
					checkMapPricing(customer, e.detail);
					if (this.productMapPricing) {
						this.productMapPricing.customer_logged_in = true;
						this.productMapPricing.init();
					}
				});
		});
	}

	initTabs() {
		if(window.innerWidth < 768) {
			this.initMobileTabs();
		} else {
			this.initDesktopTabs();
		}
	}

	initDesktopTabs () {
		const tabs = document.querySelector('.product-tab');
		const tabs_collection = tabs.getElementsByTagName('A');

		Array.from(tabs_collection).map(
			tab => new Tab( tab, {
				height: false
			})
		);
	}

	initMobileTabs () {
		new MobileTabs({
			el: '#mobile-tabs'
		});
	}
}

document.addEventListener('handlebars:helpers-loaded', function () {
	new ProductApp();
});
